// extracted by mini-css-extract-plugin
export var article = "index-module--article--8P+U0";
export var articleImg = "index-module--articleImg--xr67b";
export var articleTitle = "index-module--articleTitle--h2b9e";
export var category = "index-module--category--Mz2+Z";
export var icon = "index-module--icon--VQXS9";